import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.nav`
  position: fixed;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  text-align: left;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0,0,0,.15);
  border-radius: .25rem;
  outline: none;
  z-index: 5;
  transition: opacity 250ms ease !important;
`

class ContextMenu extends React.Component {

  onItemClick = v => this.props.onSelect && this.props.onSelect(v)

  render() {
    const { position, show, children } = this.props
    
    return (
      <Container role='menu' tabIndex='-1' style={{ left: position.x, top: position.y, opacity: show ? 1 : 0 }}>
        {
          children.map(child => React.cloneElement(child, { onItemClick: this.onItemClick }) )
        }
      </Container>
    )
  }
}

ContextMenu.defaultProps = {
  position: {x: 0, y: 0},
  show: false,
}

ContextMenu.propTypes = {
  position: PropTypes.object,
  show: PropTypes.bool,
}

export default ContextMenu



// WEBPACK FOOTER //
// ./src/components/widgets/ContextMenu.js